import {
  BinaryExpressionFactoryData,
  IdentifierExpressionFactoryData,
  LiteralExpressionFactoryData,
  ExpressionEvaluatorType,
  UnaryExpressionFactoryData
} from '../interfaces/expression-evaluator';
import { IdentifierExpression } from '../identifier-expression';
import { LiteralExpression } from '../literal-expression';
import { UnaryExpression } from '../unary-expression';
import { BinaryExpression } from '../binary-expression';

const EXPRESSION_EVALUATOR_FACTORY_MAP = {
  [ExpressionEvaluatorType.IDENTIFIER]: IdentifierExpressionFactory,
  [ExpressionEvaluatorType.LITERAL]: LiteralExpressionFactory,
  [ExpressionEvaluatorType.UNARY_EXPRESSION]: UnaryExpressionFactory,
  [ExpressionEvaluatorType.BINARY_EXPRESSION]: BinaryExpressionFactory
};

export function ExpressionEvaluatorFactory(
  data:
    | BinaryExpressionFactoryData
    | UnaryExpressionFactoryData
    | IdentifierExpressionFactoryData
    | LiteralExpressionFactoryData
    | undefined
) {
  if (!data) {
    return undefined;
  }

  return (
    EXPRESSION_EVALUATOR_FACTORY_MAP[data.type] as (
      data:
        | BinaryExpressionFactoryData
        | UnaryExpressionFactoryData
        | IdentifierExpressionFactoryData
        | LiteralExpressionFactoryData
    ) => ReturnType<
      (typeof EXPRESSION_EVALUATOR_FACTORY_MAP)[keyof typeof EXPRESSION_EVALUATOR_FACTORY_MAP]
    >
  )(data);
}

export function LiteralExpressionFactory(data: LiteralExpressionFactoryData): LiteralExpression {
  return new LiteralExpression(data.value);
}

export function IdentifierExpressionFactory(
  data: IdentifierExpressionFactoryData
): IdentifierExpression {
  return new IdentifierExpression(data.value);
}

export function UnaryExpressionFactory(data: UnaryExpressionFactoryData) {
  const expression = new UnaryExpression(data.operator);
  expression.argument = ExpressionEvaluatorFactory(data.argument) as
    | IdentifierExpression
    | LiteralExpression
    | undefined;

  return expression;
}

export function BinaryExpressionFactory(data: BinaryExpressionFactoryData) {
  const expression = new BinaryExpression();

  expression.left = ExpressionEvaluatorFactory(data.left);
  expression.right = ExpressionEvaluatorFactory(data.right);

  expression.operator = data.operator;

  return expression;
}
